export const priceFormatter = (
  price,
  decimalScale,
  thousandSeperator,
  thousandSpacing,
  decimalSepeprator,
  isprefix,
  symbol
) => {
  let beforeDecimal = ''
  let afterDecimal = ''
  let digitalGroup
  let hasdecimalvalue = true

  //if seperators is not passed setting to default values
  if (!thousandSeperator || thousandSeperator.length === 0) {
    thousandSeperator = ','
  }
  if (!decimalSepeprator || decimalSepeprator.length === 0) {
    decimalSepeprator = '.'
  }

  // setting the price to the given decimalscale
  price = Number(price).toFixed(Number(decimalScale))

  // splitting the price
  if (price.indexOf('.') !== -1) {
    const parts = price.split('.')
    beforeDecimal = parts[0]
    afterDecimal = parts[1] || ''
  } else {
    beforeDecimal = price
    afterDecimal = ''
    hasdecimalvalue = false
  }

  // adding thousand seperators based on thousandspacing
  switch (thousandSpacing) {
    case '2':
      digitalGroup = /(\d)(?=(\d{2})+(?!\d))/g
      break
    case '2s':
      digitalGroup = /(\d)(?=(((\d{2})+)(\d{1})(?!\d)))/g
      break
    case '4':
      digitalGroup = /(\d)(?=(\d{4})+(?!\d))/g
      break
    default:
      digitalGroup = /(\d)(?=(\d{3})+(?!\d))/g
  }

  beforeDecimal = beforeDecimal.replace(digitalGroup, '$1' + thousandSeperator)

  // adding currency symbol
  if (symbol) {
    if (isprefix) {
      beforeDecimal = symbol + beforeDecimal
    } else {
      afterDecimal = afterDecimal + symbol
    }
  }

  // complete formatted price
  return (
    beforeDecimal +
    ((hasdecimalvalue && decimalSepeprator) || '') +
    afterDecimal
  )
}

export const priceWithCurrencyFormatter = (
  price,
  locale,
  minimumFraction,
  currency
) => {
  const countryLocale = locale.replace('_', '-')
  let options
  if (currency) {
    options = {
      minimumFractionDigits: Number(minimumFraction),
      style: 'currency',
      currency: currency,
    }
  } else {
    options = {
      minimumFractionDigits: Number(minimumFraction),
    }
  }
  const formatter = new Intl.NumberFormat(countryLocale, options)
  return formatter.format(price)
}
